import React from "react";
import { Slide } from "react-reveal";
import ServicesList from "../reusables/ServicesList";

const CoreMarkets = () => {
  return (
    <section className="section section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="width-600">
              <p className="section-name boldTitle dark">
                NEGASH CONSTRUCTION COMPANY
              </p>
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title green">OUR SERVICES</h2>
                </div>
              </Slide>
            </div>
            <div className="section-body section-spacing-20">
              <ServicesList />
            </div>
            <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
              <a
                href="https://form.jotform.com/negashltd/lets-talk"
                target="_blank"
                rel="noopener noreferrer"
                className="button sub-cta boldTitle dark capitalize"
              >
                Let's talk about your project &#8594;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreMarkets;
